'use strict';

var angular = require('angular');
var _ = require('lodash');
var gridColumns = require('../config/competitor-data-grid-columns.json');
var gridDataFields = require('../config/competitor-data-grid-data-fields.json');
var CompetitorDataGridController = function CompetitorDataGridController($scope, dataRetriever, ColumnFactory, momentService, jqxGridSettingsService) {
  var source = {
    localdata: [],
    datafields: gridDataFields.datafields
  };
  gridColumns.columns = _.map(gridColumns.columns, function (column) {
    return new ColumnFactory(column);
  });
  $scope.gridId = 'competitor-data-grid';
  $scope.gridSettings = {
    width: '100%',
    height: 325,
    filterable: true,
    sortable: true,
    columns: gridColumns.columns,
    columngroups: gridColumns.columngroups,
    source: new angular.element.jqx.dataAdapter(source),
    localization: getLocalization()
  };
  $scope.resetGrid = function () {
    source.localdata = [];
    $scope.gridSettings.source.dataBind();
    jqxGridSettingsService.resetFilterAndSorting($scope.gridSettings);
  };
  $scope.retrieveData = function (referenceService, originalService, snapshotDate) {
    $scope.resetGrid();
    return dataRetriever.retrieveData(referenceService, originalService, snapshotDate).then(function (data) {
      source.localdata = data;
      $scope.gridSettings.source.dataBind();
    });
  };
  function getLocalization() {
    return {
      patterns: {
        DEPARTURE_DATE: momentService.FORMAT.DATE_USER_SETTINGS,
        DEPARTURE_TIME: momentService.FORMAT.TIME_USER_SETTINGS,
        OBSERVED_DATE: momentService.FORMAT.DATE_TIME_USER_SETTINGS
      }
    };
  }
};
CompetitorDataGridController.$inject = ['$scope', 'CompetitorDataGridDataService', 'CompetitorDataGridColumnFactory', 'MomentService', 'JQXGridSettingsService'];
module.exports = CompetitorDataGridController;